import _ from 'lodash';
import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { NoRecordsFoundMessage, PleaseWaitMessage, getHandlerTableChange } from './TablePaginationHelpers';
import { Pagination } from '../pagination/Pagination';
import { SubrowDefaultContent } from './subrow/SubrowDefault';

const defaultClasses = 'table-head-custom table-vertical-center overflow-hidden';
const defaultWrapperClasses = 'table-responsive';
const defaultKeyField = 'id';
const defaultSorted = [{ dataField: 'id', order: 'desc' }];
const defaultPaginationOptions = {
    custom: true,
    totalSize: 0,
    sizePerPageList: [{ text: '10', value: 10 }, { text: '25', value: 25 }, { text: '50', value: 50 }],
    sizePerPage: 10,
    page: 1
};
const defaultSubrows = {
    row: [], // { dataFiel: String, text: String}
    format: '',
    showExpandColumn: false, // boolean
    expandColumnPosition: 'left' // right | left | undefined
};

export function Table ({
    data = [],
    columns = [],
    pagination = {},
    classes = defaultClasses,
    wrapperClasses = defaultWrapperClasses,
    sort = defaultSorted,
    keyField = defaultKeyField,
    isLoading = true,
    onChange = _.noop,
    expandRow = undefined,
    subrows = defaultSubrows,
}) {
    data = data || [];
    pagination = _.defaultsDeep({}, pagination, defaultPaginationOptions);
    pagination.totalSize = data.length || 0;
    subrows = _.defaultsDeep({}, subrows, defaultSubrows);

    const defaultExpandRow = {
        // eslint-disable-next-line react/no-multi-comp, react/display-name
        renderer: (dataRow) => <SubrowDefaultContent dataRow={dataRow} subrows={subrows}/>,
        showExpandColumn: subrows.showExpandColumn, // (+)
        expandColumnPosition: subrows.expandColumnPosition,
        expanded: [], // default expandedRows,
    };

    return (
        <PaginationProvider pagination={paginationFactory(pagination)}>
            {({ paginationProps, paginationTableProps }) => {
                return (
                    <Pagination
                        isLoading={isLoading}
                        paginationProps={paginationProps}
                    >
                        <BootstrapTable
                            hover
                            remote
                            striped
                            bootstrap4
                            data={data}
                            columns={columns}
                            bordered={false}
                            keyField={keyField}
                            classes={classes}
                            wrapperClasses={wrapperClasses}
                            defaultSorted={sort}
                            onTableChange={getHandlerTableChange(onChange)}
                            {...paginationTableProps}
                            expandRow={getExpandRow(expandRow, subrows, defaultExpandRow)}
                        />

                        <PleaseWaitMessage entities={data} />
                        <NoRecordsFoundMessage entities={data} />
                    </Pagination>
                );
            }}
        </PaginationProvider>
    );
}

/**
 * Get expandRow configuration
 * Priority expandRow > subrows > undefined
 */
const getExpandRow = (expandRow, subrows, defaultExpandRow) => {
    // expandRow || ((subrows.showExpandColumn || subrows.row.length) ? defaultExpandRow : undefined)
    if (expandRow) return expandRow;
    if (subrows?.showExpandColumn || subrows?.row?.length) {
        return defaultExpandRow;
    }
    return undefined;
};
